module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/youtube_big-180db82851303a0231d0277e882e1f35.svg";